import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { MatIcon } from '@angular/material/icon';

import { TASK_DATA } from '../../../core/contracts/task-data.contract';
import { Task, TaskType } from '../../../core/models/task.interface';
import { TaskDataTargetComponent } from '../../commons/task-data-target/task-data-target.component';
import { TextSeparatorComponent } from '@lib/shared-ui/commons/text-separator/text-separator.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-process-guarantee-application-task-summary',
  standalone: true,
  imports: [MatIcon, TaskDataTargetComponent, TextSeparatorComponent],
  template: `
    <div class="flex flex-col gap-1">
      <app-task-data-target (click)='navigateToMemberProfile()'>
        <mat-icon icon>account_circle</mat-icon>
        <span text>{{ task.data.memberName }}</span>
      </app-task-data-target>
      <div class="flex items-center gap-2 text-neutral-500">
        <p class='font-bold'>{{ task.data.description }}</p>
        <shared-text-separator />
        <p>{{ task.data.doctorName }}</p>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProcessGuaranteeApplicationTaskSummaryComponent {
  protected readonly router = inject(Router);
  protected readonly task = inject<Task<TaskType.ProcessGuaranteeApplication>>(TASK_DATA);

  protected navigateToMemberProfile() {
    this.router.navigate(['/members', this.task.data.memberId]);
  }
}
